module.exports = __webpack_public_path__ + "assets/img/3.8d959585.jpg";